import { cn } from '../../lib/utils';
import type { Subject } from '../../types/wizard';
import { BookOpen, Check } from 'lucide-react';

interface SubjectCardProps {
  subject: Subject;
  isSelected: boolean;
  onSelect: (subject: Subject) => void;
}

export function SubjectCard({ subject, isSelected, onSelect }: Readonly<SubjectCardProps>) {
  return (
    <button
      type="button"
      onClick={() => onSelect(subject)}
      className={cn(
        'relative flex flex-col items-start gap-3 rounded-2xl border-2 p-5 text-left transition-all duration-200 focus:outline-none w-full group',
        isSelected
          ? 'border-violet-500/50 bg-violet-500/10 shadow-glow'
          : 'border-slate-700 bg-slate-700/50 hover:border-violet-500/40 hover:bg-violet-500/10 hover:-translate-y-0.5 hover:shadow-card-hover'
      )}
    >
      <div
        className={cn(
          'flex h-11 w-11 items-center justify-center rounded-xl transition-all duration-200 group-hover:scale-105',
          isSelected
            ? 'bg-gradient-to-br from-violet-500 to-indigo-600 text-white shadow-md shadow-violet-500/25'
            : 'bg-slate-700 text-slate-400'
        )}
      >
        <BookOpen className="h-5 w-5" />
      </div>
      <div>
        <p className={cn('font-semibold', isSelected ? 'text-violet-300' : 'text-white')}>
          {subject.name}
        </p>
        <p className="text-xs text-slate-400 mt-0.5 font-medium">{subject.code}</p>
      </div>
      {isSelected && (
        <span className="absolute top-3 right-3 flex h-5 w-5 items-center justify-center rounded-full bg-brand-600 text-white">
          <Check className="h-3 w-3" strokeWidth={3} />
        </span>
      )}
    </button>
  );
}
